import includes from "lodash-es/includes"

import { EVideoRendererSourceProvider as EProvider } from "./video-renderer.types"

function getVideoLinkByProvider(url: string, provider: EProvider): string {
    switch (provider) {
        case EProvider.Vimeo:
            return includes<string>(url, "vimeo") ? url : `https://vimeo.com/${url}`
        default:
            return url
    }
}

const utils = { getVideoLinkByProvider }

export { utils as videoRendererUtils }
